import { resolveApiErrorMessage } from 'api/base';
import projectCoordinatorApi from 'api/project-coordinator';
import { validateEntity } from 'helpers/form-validations';
import notification, { NotificationType } from 'helpers/notification';
import getPayload from './get-payload';
import { TaskFormActions, TaskFormModel } from '../reducer';
import { validationRules } from '..';

export default function onSave(dispatch, formData: TaskFormModel, oldData: any[], orderId) {
  return () => {
    dispatch({ type: TaskFormActions.START_SAVING });

    const { hasErrors, errors } = validateEntity(formData, validationRules);

    if (hasErrors) {
      return dispatch({
        type: TaskFormActions.SET_VALIDATION_ERRORS,
        payload: errors,
      });
    }

    const onSuccess = ({ data }) => {
      const message = 'Note Successfully Saved';
      notification({ type: NotificationType.SUCCESS, message });

      const payload = [...oldData, { label: data.details, value: data.id, priority: data.priority }];

      dispatch({ type: TaskFormActions.SAVE_ONETIME_TASK, payload });
    };

    const onError = (error) => {
      const message = resolveApiErrorMessage((error as any).response);
      notification({ type: NotificationType.ERROR, message });
    };

    const onFinally = () => {
      dispatch({ type: TaskFormActions.FINISH_SAVING });
    };

    const payload = getPayload(formData, oldData[oldData.length - 1]);

    return projectCoordinatorApi.addOnetimeTask(orderId, payload)
      .then(onSuccess)
      .catch(onError)
      .finally(onFinally);
  };
}
